import React from "react";
import { PageHeader, Container, PageFooter } from "components/commons";
import classnames from "classnames";

const LayoutA = ({ children, padding, logoRedirectUrl, hasUserNav = true }) => {
  return (
    <div className={classnames("flex flex-col h-full bg-gray-lightest")}>
      <PageHeader hasUserNav={hasUserNav} logoRedirectUrl={logoRedirectUrl} />
      <div className="h-15 min-h-15" />
      <Container
        padding={padding}
        className={classnames("flex justify-center flex-grow overflow-y-auto")}
      >
        <div className="w-full flex justify-center md:my-auto">{children}</div>
      </Container>
      <PageFooter />
    </div>
  );
};

export default LayoutA;
